import moment from 'moment';
import { LANGUAGE_EN } from '@home/_config/config';
import { formatReleaseTime } from '@home/components/NavHeader/sreachContext/utils';
import { GRANULARITY_MOMENT_HELPER_MAPPING } from '@intelligence/utils/dateUtils';
import { filterPlatformIcons } from '@intelligence/utils/common';

const buildAlignReleaseDateFormatter = (getReleaseDateDiff: (value?: any, data?: any, params?: any) => string) => {
  return (value?: any, data?: any, params?: any) => {
    const isSpecialReleaseTime = data?.is_special_release_time;
    const releaseTime = data?.release_time;
    const releaseTimeEN = data?.release_time_en;
    const releaseTimeCN = data?.release_time_cn;
    const releaseDateDiff = getReleaseDateDiff(value, data, params);

    const releaseDateFormatted = formatReleaseTime(LANGUAGE_EN, {
      isSpecialReleaseTime,
      releaseTime,
      releaseTimeEN,
      releaseTimeCN,
    });
    if (!releaseDateFormatted) return '';
    if (isSpecialReleaseTime) return releaseDateFormatted;

    const releaseDateFormattedM = moment(releaseDateFormatted);
    if (!releaseDateFormattedM.isValid()) return releaseDateFormatted;

    const releaseDateDiffNum = Number.parseInt(releaseDateDiff, 10);
    if (Number.isNaN(releaseDateDiffNum)) return releaseDateFormatted;

    const granularity = params?.granularity;
    const granularityMomentHelper =
      GRANULARITY_MOMENT_HELPER_MAPPING[granularity] || GRANULARITY_MOMENT_HELPER_MAPPING.daily;

    // @ts-ignore
    return releaseDateFormattedM.add(releaseDateDiffNum, granularityMomentHelper.amounts).format('YYYY-MM-DD');
  };
};

/**
 * 针对excel表数据部分
 * 单元格value formatter方法配置
 */
const formatters: Record<string, Function> = {
  release_date: (value?: unknown, cvm?: any) => {
    const isSpecialReleaseTime = cvm?.is_special_release_time;
    const releaseTime = cvm?.release_time;
    const releaseTimeEN = cvm?.release_time_en;
    const releaseTimeCN = cvm?.release_time_cn;
    return formatReleaseTime(LANGUAGE_EN, {
      isSpecialReleaseTime,
      releaseTime,
      releaseTimeEN,
      releaseTimeCN,
    });
  },
  align_release_date: buildAlignReleaseDateFormatter((value) => value),
  align_release_start_date: buildAlignReleaseDateFormatter((_value, _data, params) => params?.start_release_time),
  align_release_end_date: buildAlignReleaseDateFormatter((_value, _data, params) => params?.end_release_time),
  /**
   * Formats game_engine field for Excel export
   * Converts array like ["Unity", "Unreal"] to pipe-delimited string "Unity|Unreal"
   * Also handles JSON string format like '["Unity", "Unreal"]'
   */
  game_engine: (value?: any) => {
    if (!value) return '';
    // If already a string, check if it's JSON array format
    if (typeof value === 'string') {
      // Try to parse JSON array string like '["Unity", "Unreal"]'
      try {
        const parsed = JSON.parse(value);
        if (Array.isArray(parsed)) {
          return parsed.join('|');
        }
      } catch {
        // Not JSON, return as-is (might already be pipe-delimited)
        return value;
      }
      return value;
    }
    // If array, join with pipe
    if (Array.isArray(value)) {
      return value.join('|');
    }
    return String(value);
  },
  supported_platforms: (value?: any) => {
    if (Array.isArray(value))
      return filterPlatformIcons(value)
        .filter((v: string) => v !== 'ios' && v !== 'android')
        .map((v: string) =>
          v === 'pc'
            ? 'First-Party Launcher'
            : v === 'ps'
              ? v.toUpperCase()
              : v.charAt(0).toUpperCase() + v.slice(1)
        )
        .join('|');
    return value || '';
  },
};

export default formatters;
